export default __webpack_public_path__ + "static/media/semsPortalZhApp.709ace6b.png";